import {
  User,
  FileText,
  Calendar,
  Copy,
  Phone,
  Mail,
  MapPin,
} from "lucide-react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export type TabType = "profile" | "notes";

export interface ProfileTab {
  id: TabType;
  label: string;
  icon: typeof User;
}

export const profileTabs: ProfileTab[] = [
  {
    id: "profile",
    label: "Profile",
    icon: User,
  },
  {
    id: "notes",
    label: "Notes",
    icon: FileText,
  },
];

interface PatientInfoField {
  label: string;
  field: string;
  icon: typeof Calendar;
}

export const patientInfoFields: PatientInfoField[] = [
  {
    label: "Date of birth",
    field: "dateOfBirth",
    icon: Calendar,
  },
  {
    label: "Gender",
    field: "sex",
    icon: User,
  },
  {
    label: "NHS No.",
    field: "nhsNumber",
    icon: Copy,
  },
  {
    label: "Telephone",
    field: "phone",
    icon: Phone,
  },
  {
    label: "Email",
    field: "email",
    icon: Mail,
  },
  {
    label: "Address",
    field: "fullAddress",
    icon: MapPin,
  },
];

export const getPatientInfoItems = (patientData: any) => {
  try {
    if (!patientData) return [];
    let phone = "—",
      addressLine2 = null,
      addressLine1 = null;

    if (
      patientData?.preferredAddress?.address?.addressLine1 != null &&
      patientData?.preferredAddress?.address?.addressLine1.trim() !== ""
    ) {
      addressLine1 = patientData.preferredAddress.address.addressLine1;
    } else if (
      patientData?.preferredAddress?.address?.houseName != null ||
      patientData?.preferredAddress?.address?.streetName != null
    ) {
      const houseStreet = [
        patientData.preferredAddress.address.houseName,
        patientData.preferredAddress.address.streetName,
      ]
        .filter((v) => v && v.trim() !== "")
        .join(" ");
      addressLine1 = houseStreet !== "" ? houseStreet : null;
    } else if (
      patientData?.address != null &&
      patientData?.address.trim() !== ""
    ) {
      addressLine1 = patientData?.address;
    }

    if (
      patientData?.preferredAddress?.address?.addressLine2 != null &&
      patientData?.preferredAddress?.address?.addressLine2.trim() !== ""
    ) {
      addressLine2 = patientData.preferredAddress.address.addressLine2;
    } else if (
      patientData?.preferredAddress?.address?.locality != null ||
      patientData?.preferredAddress?.address?.town != null ||
      patientData?.preferredAddress?.address?.postcode != null
    ) {
      addressLine2 = [
        patientData.preferredAddress.address.locality,
        patientData.preferredAddress.address.town,
        patientData.preferredAddress.address.postcode,
      ]
        .filter((v) => v && v.trim() !== "")
        .join(", ");
    }

    if (
      patientData?.preferredContact?.contactType === 2 ||
      patientData?.preferredContact?.contactType === 4
    ) {
      if (patientData?.preferredContact?.value.trim() !== "") {
        phone = patientData.preferredContact.value || "—";
      }
    }

    if (
      Array.isArray(patientData?.contacts) &&
      patientData?.contacts.length > 0 &&
      patientData?.contacts[0]?.value != null &&
      patientData?.contacts[0]?.value.trim() !== ""
    ) {
      phone = patientData?.contacts[0]?.value || "—";
    } else if (
      patientData?.preferredContact?.contactType === 2 ||
      patientData?.preferredContact?.contactType === 4
    ) {
      if (patientData?.preferredContact?.value.trim() !== "") {
        phone = patientData.preferredContact.value || "—";
      }
    }

    const gender =
      patientData.sex === 1
        ? "Male"
        : patientData.sex === 2
          ? "Female"
          : "Other / Not specified";

    return [
      {
        label: "Date of birth",
        value: patientData.dob
          ? // ? new Date(patientData.dob).toLocaleDateString("en-GB")
            dayjs.utc(patientData.dob).format("DD/MM/YYYY")
          : "—",
        icon: Calendar,
      },
      {
        label: "Gender",
        value: gender,
        icon: User,
      },
      {
        label: "NHS No.",
        value: patientData.nhsNumber || "—",
        icon: Copy,
      },
      {
        label: "Phone",
        value: phone,
        icon: Phone,
      },
      {
        label: "Email",
        value: patientData.email || "—",
        icon: Mail,
      },
      {
        label: "Address Line 1",
        value: addressLine1 == null ? "—" : addressLine1,
        icon: MapPin,
      },

      ...(addressLine2 && addressLine2.trim() !== ""
        ? [
            {
              label: "Address Line 2",
              value: addressLine2 == null ? "—" : addressLine2,
              icon: MapPin,
            },
          ]
        : []),
    ];
  } catch (error) {
    console.log(error);
  }
};
